const localizers = {
  'loading.msg': () => `טוען...`,
  'logon.message.msg': () => `חובה לבצע אימות. הזן מזהה משתמש וסיסמה חוקיים.`,
  'logon.button.msg': () => `נכנס...`,
  'SASServer.logonError.msg': () => `לא ניתן להתחבר לשרת.`,
  'SASServer.genericError.msg': () => `לא ניתן להתחבר לשרת.`,
}
export default localizers;
